import React from 'react'
import 'raf/polyfill'
import 'babel-polyfill'
import { connect } from 'react-redux'
import comFn from '../../component/common/common'
import axios from 'axios'
import HeaderBar from '../../component/header/header.js'
import LeftNav from '../../component/left-nav/leftNav.js'
import Login from '../../component/login/login.js'
import { Link} from "react-router-dom"
import {getBigBGUrl} from '../../redux/chatuser.redux.js'
import {userList} from '../../redux/chatuser.redux.js'
import {getElementPosition} from '../../util.js'
import GiftAlert from '../../component/gift-alert/gift-alert.js'
import {xxflStaus} from '../../redux/newGame.redux.js'
import './detail.css'
import ToastBar from '../../component/toast/toast.js'
@connect(
  state=>state.chatuser,
  {getBigBGUrl}
)
@connect(
  state=>state.chatuser,
  {userList}
)
@connect(
  state=>state.newGame,
  {xxflStaus}
)
class Xinxiang extends React.Component{
	constructor(props){
		super(props)
		this.state={
			tabDataNum:1,
			getGameDesc:'',
			getCatesData:'',
			getCatesDataNum:0,
			getpackData:'',
			getpackData2:'',
			iNum:0,
			showSelectWelfare:false,
			visible:false,
			
			visible2:false,
			showGetSuccess:false,
			key:0,
			myUserList:'',
			strSta:'',
			packTypeData:''

    	}
    	
    
    	this.tabData = ['游戏介绍','等级礼包','新手礼包']
    	this.GameId = this.props.match.params.id
    	this.cateId = ''
    	this.iNum = 0
    	this.successCallBack = this.successCallBack.bind(this)
    	this.oLdId=''
    	
	}
	componentDidMount(){
  
    	this.getGameDesc()
    	this.getPackType()
		//this.getCates(2)  //默认显示等级礼包
    	/*componentWillReceiveProps不触发时*/

    	if(this.props.xxfl&&this.props.xxfl===1){
    		if(this.props.userlist.displayAccount){return}
    		this.setState({
  				myUserList:{code:-1}
  			})
    	}
    	
  	}
  	componentWillReceiveProps(nextProps){
		
  		
  		if(this.props.userlist!==nextProps.userlist){
			
  			this.setState({
  				myUserList:nextProps.userlist
  			})
  			
  			
  		}
  		
  	}
  	handleGameList(ieq){
  		
  		 
  	}
  	handleTabNum(i,_id){
  		this.setState({
  			tabDataNum:i,
  			getCatesDataNum:0
  		})
  		if(i===0){

  		}else{
  			
  			this.getCates(_id)
  		}
  		
  		
  	}
  	handleCatesDataNum(i,_id){
  		this.setState({
  			getCatesDataNum:i,
  			iNum:0
  		})
  		this.getpack(_id)
  		this.oLdId = _id
  		
  	}
  	getPackType(){
  		axios.get('/fapi/index/getPackType/'+this.GameId)
  			.then(res=>{
  				if(res.data.return_code===0){
  						
  					const data1={
  						"pack_cate_name": "游戏介绍", 
						"pack_type": "-10", 
  					}
  					res.data.data.unshift(data1)
  				
  					this.setState({
  						packTypeData:res.data.data
  					})

  					res.data.data[1]&&this.getCates(res.data.data[1].pack_type) ///默认显示第二个礼包
  				}
  				
  			})
  		
  	}
  	
  	getGameDesc(){
  		axios.get('/fapi/index/getGameDesc/'+this.GameId)
  			.then(res=>{
  				
  				if(res.data.return_code===0){
  					this.setState({
						getGameDesc:res.data.data
					})
  				}

  				if(res.data.return_code===-2301000){
  					this.props.history.push('/404')
  				}
				
  			})
  	}

  	getCates(iType){
  		//if(iType===1){return}
  		
  		if(iType===-10){return}
  		axios.get('/fapi/recom/getCates?gameid='+this.GameId+'&type='+iType+'')
			
  			.then(res=>{
  				if(res.data.return_code===0){


	  				this.setState({
	  					getCatesData:res.data.data
	  				})
	  				this.oLdId = res.data.data[0].id
	  				res.data.data.length&&this.getpack(res.data.data[0].id)
				}
  			})
  	}
  	getpack(_id){
  		
  		this.setState({
  			getpackData:''
  		})

  		axios.get('/fapi/index/getpack?gameid='+this.GameId+'&cateid='+_id)
  			.then(res=>{
  				if(res.data.return_code===0){
  					console.log(res)
  					this.setState({
  						getpackData:res.data.data,
  						getpackData2:res.data
  					})

  					
  				}
  				
  				
  			})	
  	}
  	handleChange(e){
  		
		this.setState({
			iNum:e.target.options[e.target.options.selectedIndex].getAttribute('_num')
		})
  		
  	}
  	showAlert(e){
  		if(!this.state.getpackData2.is_need_loginbox){
			this.setState({	  			
	  			visible2:true,
			  			
  			})
  		}else{
  			this.setState({
	  			showSelectWelfare:true,
	  			visible:false,
	  			showGetSuccess:false,
	  			iTop:getElementPosition(e.target).y+'px',
	  			key:this.state.key+1
  					
  			
  			})
  		}
  		
  	}
  	handleLogin(){
  		/*
		axios.get('/fapi/getLoginURL?redirect_url='+window.location.href)
	      .then(res=>{
	       	if(res.data.return_code==0){
				
	       		window.location.href = res.data.redirect_url
	       		
	       	}
	     
	    })
	    */
	    const iDetail = '/game-detail/'+this.GameId 
	    const ipath = {
	         pathname:'/login',
	         query:iDetail
    	}
    
    	this.props.history.push(ipath)
  	}
  	successCallBack(data){
  		//领取后回调
  		
  		this.getpack(this.oLdId)
  	}
  	exchangeLogin(){
  		
  		const myHref = window.location.origin+'/login'
  		window.location.href ="/fapi/logoutB?returnUrl="+encodeURIComponent(myHref)
  	}
  	render(){
  		return(
			<div className="my-wrap" style={{backgroundImage :'url('+this.props.bigBg+')',transform:document.documentElement.clientWidth<600?'scale(0.3)':'scale(1)',top:document.documentElement.clientWidth<600?'-360px':'0px'}}>
				<HeaderBar></HeaderBar>
				<div className="xinxiang-detail clearfix">
					<Login showLogin={this.props.showLogin}>
		               
		            </Login>
					<div className="xinxiang-con">
						<div className="news-from game-from">
							<Link to="/index">首页</Link> &gt; <Link to="/new-game">游戏推荐</Link> &gt;  			
							<a href="javascript:;">{this.state.getGameDesc.gamename}</a>
						</div>
						<div className="title">
							<span style={{backgroundImage:'url('+this.state.getGameDesc.imgurl+')'}}></span>
							<div>
								<strong>{this.state.getGameDesc.gamename}</strong>
								<p>{this.state.getGameDesc.description}</p>
							</div> 
							<a href={this.state.getGameDesc.appurl} target="_blank"></a>
						</div>
						<div className="xinxiang-gift">
							<nav className="clearfix">
								{
									this.state.packTypeData&&this.state.packTypeData.map((item,i)=>(
										<span 
											key={i}
											className={ this.state.tabDataNum===i?'active':''}
											onClick={()=>this.handleTabNum(i,item.pack_type)}
											style={{width:705/this.state.packTypeData.length+'px'}}


										>{item.pack_cate_name}</span>
									))
								}
								
								
							</nav>
							
								{ 
									this.state.tabDataNum===0?<div className="game-into">
										<h6>游戏视频</h6>
										{
											this.state.getGameDesc.video_tag==0?null:
												this.state.getGameDesc.video_tag==1?
													<embed 
														src={this.state.getGameDesc.video_url}
														width="700px"
														height="394px"
													 />:
																							
														<iframe 					
															width="700px" 
															height="393px" 
															src={this.state.getGameDesc.video_url}
															scrolling="no" 
															border="0" 
															frameBorder="no" 
															framespacing="0" 
															allowFullScreen={true}>
														</iframe>
										}
										
										<h6>游戏简介</h6>
										<p>{this.state.getGameDesc.introduction}</p>
									</div>:null
								}
								{
									this.state.tabDataNum!==0?
										<div className="x-grade-gift">
											<div className="x-gift-tab">
												{
													this.state.getCatesData&&this.state.getCatesData.map((item,i)=>(
														<span 
															className={
																this.state.getCatesDataNum===i?
																	'active':''
															}
															onClick={()=>this.handleCatesDataNum(i,item.id)} 
															key={i}
														>{item.name}</span>
													))
												}
											</div>

											<div className="x-gift-con">
												{
													this.state.getpackData.length>1?<select onChange={(e)=>this.handleChange(e)}>
														{
															this.state.getpackData&&this.state.getpackData.map((item,i)=>(
																<option
																	 key={i}
																	 value={item.sub_cate_name}
																	 _num={i}
																>{item.sub_cate_name}</option>
															))
														}
														
														
													</select>:null
												}
												<ul className="clearfix">
													{
														this.state.getpackData?this.state.getpackData[this.state.iNum].images.map((item,i)=>(
															<li key={i}>
																<span style={{backgroundImage :'url('+item.imgurl+')'}}></span>
																<strong>{item.title}</strong>
															</li>
														)):<div className="loading">正在加载中...</div>
														
													}	

												</ul>
												{
													this.state.getpackData?<div className="get-related">
														{
															this.state.getpackData&&this.state.getpackData[this.state.iNum].can_receive===0?
																<button 
																	className={
																		this.state.myUserList.code===-1?
																		'a-active':'active'
																	}
																	onClick={this.state.myUserList.code===-1?()=>this.handleLogin():null}
																>{this.state.myUserList.code===-1?'领取福利':'待解锁'}</button>:
																	this.state.getpackData&&this.state.getpackData[this.state.iNum].can_receive===1?
																		<button onClick={(e)=>this.showAlert(e)}>领取福利</button>:
																			this.state.getpackData&&this.state.getpackData[this.state.iNum].can_receive===4?
																				<button className="active">今日已领完</button>:
																					<button className="active">已领取</button>

														}
														
														<span>{this.state.getpackData&&this.state.getpackData[this.state.iNum].num}人已领取福利</span>
													</div>:null
												}
												
											</div>

										</div>:null
								}
								
							
						</div>

					</div>
					
				</div>
				{
					this.state.showSelectWelfare&&<GiftAlert
						key={this.state.key}
						showSelectWelfare={this.state.showSelectWelfare}
						visible={this.state.visible}
						showGetSuccess={this.state.showGetSuccess}
						iTop={'400px'}
						iTitle={"游戏礼包推荐"}
						giftData={{'id':this.state.getpackData?this.state.getpackData[this.state.iNum].good_id:null}}
						packId={this.state.getpackData?this.state.getpackData[this.state.iNum].id:null}
						successCallBack={this.successCallBack}			
					></GiftAlert>

				}
				
				<ToastBar 
					visible={this.state.visible2} 
					title={'温馨提示'}  
					isOkShow ={false} 
					iTop={'600px'}
				>	
				{	
					this.state.getpackData2.thirdGame&&
					<div className="third-login-notice">
						<strong>检测到您的登录身份为：{this.state.getpackData2.thirdGame.gamename}WeGame</strong>
						<span>无法领取等级礼包</span>
						<button onClick={()=>this.exchangeLogin()}>切换登录</button>
					</div>
				}
				</ToastBar>

				
			</div>
  		)
  	}
	
}

export default Xinxiang



// WEBPACK FOOTER //
// ./src/container/xinxiang-detail/detail.js